import { ConfigurationService } from '@nsftx/games-config';
import { BusService } from '@nsftx/games-bus';
import { bus } from '@/utility';
import { socket } from '@/plugins';
import { ticketApi } from '@/api';
import { v4 } from 'uuid';
import { ulid } from 'ulid';
import {
  assign,
  capitalize,
  each,
  findIndex,
  has,
  isNumber,
  template,
} from 'lodash';
import isMobile from 'ismobilejs';
import store from '../store';

const qp = new URLSearchParams(window.location.search);
let config = null;
let busService = null;

const getLocale = (locale) => {
  const localeToUse = locale;

  switch (localeToUse) {
    case 'pt-BR':
      return 'pt';
    case 'bs':
      return 'hr';
    case 'sr':
      return 'sr-Latn';
    default:
      return localeToUse;
  }
};

const setMetadata = () => {
  const reqUuid = v4();
  const metadata = store.getters.metadata(reqUuid);

  metadata.providerBetslipId = ulid();
  metadata.paymentMethod = 'VirtualMoney';
  metadata.requestUuid = reqUuid;
  metadata.productId = store.getters.platform.productId;
  metadata.companyId = store.getters.platform.platformConfig.tenantId;
  metadata.currency = store.getters.platform.currency;
  metadata.platform = store.getters.platform.platformName;
  metadata.locale = store.getters.platform.locale;

  return metadata;
};

const sendNotification = (notification) => {
  store.dispatch('setErrorMessage', notification);
  store.dispatch('setInfoMessage', {
    message: notification,
    messageType: 'error-style',
    icon: 'n-i-void',
    closeIconActive: false,
    delay: 1500,
  });
};

const validateBetslip = (ticket) => {
  let notification = null;
  let valid = true;
  const { limits } = store.getters;

  each(ticket.bets, (bet) => {
    /* eslint-disable */
      if (isNumber(store.getters.balanceAmount) && (ticket.payment > store.getters.balanceAmount)) {
        notification = template(store.getters.translations.invalidBalance)(limits.ticket);
        sendNotification(notification);
        valid = false;
      } else if (bet.payment < limits.bet.ticketBetMinPayment) {
        notification = template(store.getters.translations.invalidBetPayment)(limits.bet);
        sendNotification(notification);
        valid = false;
      } else if (bet.payment > limits.bet.ticketBetMaxPayment) {
        notification = template(store.getters.translations.invalidBetPayment)(limits.bet);
        sendNotification(notification);
        valid = false;
      } else if (ticket.payment < limits.ticket.ticketMinPayment) {
        notification = template(store.getters.translations.invalidTicketPayment)(limits.ticket);
        sendNotification(notification);
        valid = false;
      } else if (ticket.payment > limits.ticket.ticketMaxPayment) {
        notification = template(store.getters.translations.invalidTicketPayment)(limits.ticket);
        sendNotification(notification);
        valid = false;
      }
    });

    return valid;
  };


const events = {
  onBettingDenied() {
    store.dispatch('setBettingAvailability', false);
  },
  onBettingAllowed() {
    store.dispatch('setBettingAvailability', true);
  },
  UserBalanceChanged(payload) {
    store.dispatch('setBalance', payload.data.balance);
  },
  UserAuthorizationChanged(payload) {
    const { user } = payload.data.auth;
    if (user) {
      store.dispatch('setUser', {
        user: {
          id: user.id,
          uuid: user.id,
          firstName: user.firstName,
          lastName: user.lastName,
          name: user.name,
          logged: user.token, // use logged param
          auth: {
            token: user.token,
          },
        },
      });
    }
  },
};

export default {
  async init() {
    const tenantId = qp.get('tenantId');
    const language = qp.get('locale') || 'en';
    const deliveryPlatform = qp.get('deliveryPlatform') || qp.get('application') || 'web';
    const messageProtocol = qp.get('messageProtocol') || qp.get('integrationType') || 'postMessage';

    const configService = new ConfigurationService({
      environment: process.env.NODE_ENV,
      requiredPaths: [],
      applicationName: deliveryPlatform === 'web' ? capitalize(deliveryPlatform) : deliveryPlatform,
      locale: getLocale(language),
      messageProtocol,
      clientAdapters: [
        {
          name: 'IgniteAdapter',
          options: {
            allowedOrigins: '*',
            displayId: 'Roulette',
            version: '1.1',
            providerId: 26,
          },
        },
      ],
    });
    config = await configService.getConfiguration();
    store.dispatch('initializeConfiguration', config.rawData);
    socket.init(config.rawData);
    const {
      applicationName,
      productName,
      productId,
      locale,
      platformName,
      platformConfig,
      wheel,
    } = config;
    store.dispatch('setPlatform', {
      channel: 'web',
      isIntegration: true,
      platformName,
      isMobile: isMobile().any.toString(),
      currency: wheel.wheelAccountCurrency,
      productId,
      productName,
      platformConfig,
      locale,
      applicationName,
      companyUuid: tenantId,
      companyLanguage: locale,
    });
    store.dispatch('setLimits');
    store.dispatch('setPresets');
    this.initBusService();
  },
  initBusService() {
    busService = new BusService({
      environment: config.environment,
      platform: config.platformName,
      productName: config.productName,
      productId: config.productId,
      tenantId: config.tenantId,
      locale: config.locale,
      applicationName: config.applicationName,
      useCommonEventName: true,
      adapters: [],
      clientMessageProtocol: config.messageProtocol,
    });
    busService.start();
    // mapped event in bus service
    busService.sendMessage({
      action: 'Slave.Loaded',
      enforceEvent: true,
    }, true);
  },
  payInTicket() {
    const ticket = assign(store.getters.ticketConfiguration, store.getters.ticket);
    if (ticket.round.id && ticket.round.displayId) {
      if (validateBetslip(ticket)) {
      const headers = {};
      const additionalInfo = {};
      const metadata = setMetadata();

      store.dispatch('setInfoMessage', {
        message: store.getters.translations.rouletteInfoBarTicketProcess,
        messageType: 'warning-style',
        icon: 'n-i-status-b',
        closeIconActive: false,
      });
      store.dispatch('clearTicket');
      bus.$emit('clearChips');
      bus.$emit('ticketIsProcessing');
      return ticketApi.createTicket({
        additionalInfo,
        headers,
        metadata,
        ticket,
        tenantEndpoint: process.env.VUE_APP_NEXT_GEN_API,
        path: '/nextgen/ticket/add',
      }).then((response) => {
        const result = response.data;
        const ticketIndex = findIndex(store.getters.ticketStore, ['requestUuid', result.requestUuid]);
        if (ticketIndex > -1) {
          store.dispatch('removeTicketFromTicketStore', result);
        } else {
          store.dispatch('addTicketToTicketStore', result);
        }
        bus.$emit('ticketIsResolved', true);
        bus.$emit('refreshTicketList');
        store.dispatch('setInfoMessage', {
          message: template(store.getters.translations.rouletteInfoBarConfirmedTicket)({
            id: result.details.barcode,
          }),
          messageType: 'success-style',
          icon: 'n-i-check',
          closeIconActive: false,
          delay: 2000,
        });
      }).catch((error) => {
        // if (error.response?.status === 403) this.logoutUser();
        const message = error.message ? error.message : error;
        const errorCode = error ? error.code : 0;
        const isVerification = errorCode === 11000;
        const closeIconActive = isVerification;
        const delay = isVerification ? 5000 : 2000;

        store.dispatch('setInfoMessage', {
          message,
          messageType: 'error-style',
          icon: 'n-i-void',
          closeIconActive,
          delay,
          action: undefined,
        });

        bus.$emit('ticketIsResolved');
      });
    }
  }
    return false;
  },
  setListeners() {
  window.addEventListener('message', (event) => {
    if (event.data.action === 'User.AuthorizationChanged') {
   const { user, token } = event.data.data.auth;
    if (user) {
      store.dispatch('setUser', {
        user: {
          id: user.id,
          uuid: user.id,
          firstName: user.firstName,
          lastName: user.lastName,
          name: user.name,
          logged: token, // use logged param
          auth: {
            token: token,
          },
        },
      });
    }
    }
    if (event.data.action === 'User.BalanceChanged') {
       store.dispatch('setBalance', event.data.data.balance);
    }
  });
    window.addEventListener('Configuration:SetConfiguration', (platformData) => {
      store.dispatch('setPlatform', {
        channel: platformData.detail.channelId,
        isMobile: qp.isMobile || null,
        isIntegration: platformData.detail.isIntegration || null,
        currency: platformData.detail.ignite.activeCurrency.code,
        productId: platformData.detail.ignite.consumer.id,
        productName: platformData.detail.ignite.consumer.displayId || null,
        productTitle: platformData.detail.ignite.consumer.displayId || null,
        ignite: platformData.detail.ignite,
      }); 
    });

    window.addEventListener('Bus:Message', (event) => {
      const eventName = event.detail.action.split('.').join('');
      if (has(events, eventName)) {
        events[eventName](event.detail.rawData);
      }
    });

    bus.$on('openPlayerRegistrationForm', () => {
      busService.sendMessage({
        action: 'User.LoginRequired',
        enforceEvent: true,
      }, true);
    });
  },
};